import { OrdersActionTypes } from "./constants";

export interface orderActionType {
  type:
    | OrdersActionTypes.API_RESPONSE_SUCCESS
    | OrdersActionTypes.API_RESPONSE_ERROR
    | OrdersActionTypes.GET_ORDERS_REVENUE
    | OrdersActionTypes.GET_ORDERS;
  payload: {} | string;
}

// common success
export const ordersApiResponseSuccess = (
  actionType: string,
  data: any | {}
): orderActionType => ({
  type: OrdersActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const ordersApiResponseError = (
  actionType: string,
  error: string
): orderActionType => ({
  type: OrdersActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const getOrders = (filter: string, status: string): orderActionType => ({
  type: OrdersActionTypes.GET_ORDERS,
  payload: { filter, status },
});

export const getOrdersRevenue = (
  type: string,
  from: string,
  to: string,
  pathname: string
): orderActionType => ({
  type: OrdersActionTypes.GET_ORDERS_REVENUE,
  payload: { type, from, to, pathname },
});
